import { render, staticRenderFns } from "./trainingdetail.vue?vue&type=template&id=1a4109c2&"
import script from "./trainingdetail.vue?vue&type=script&lang=js&"
export * from "./trainingdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports